import React, { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import { useHistory } from "react-router-dom";
import "./CMSContent.scss";
import { CMSContentWrapper } from "@sia/style-guide";
import cmsAdapter from "common/Adapters/CMSAdapter/CMSAdapter";

const CMSContent = ({ nodeId, isHash }) => {
  const history = useHistory();
  const { language: languageKey, menuItems, noMenuPages } = useContext(GlobalContext);
  return (
    <div className="cms-content">
      {languageKey && (
        <CMSContentWrapper
          cmsAdapter={cmsAdapter}
          history={history}
          nodeId={nodeId}
          isHash={isHash}
          languageKey={languageKey}
          menuItems={menuItems}
          noMenuPages={noMenuPages}
          environment="web-plattform"
        />
      )}
    </div>
  );
};

export default CMSContent;
